import { render, staticRenderFns } from "./TeamPlayerSelector.vue?vue&type=template&id=541e5c54&"
import script from "./TeamPlayerSelector.vue?vue&type=script&lang=js&"
export * from "./TeamPlayerSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports